(ns com.theplantscape.plant-web.draw.components.ui-svg-diagram
  (:require
   [com.theplantscape.plant-web.draw.state :refer [site-data]]
   [com.theplantscape.svg-generation.patterns
    :refer [svg-no-pattern svg-pattern-1 svg-pattern-2 svg-pattern-3 svg-pattern-4]]
   [com.theplantscape.svg-generation.filters
    :refer
    [bush-filter goo-filter ground-filter tree-filter hatch-filter]]
   [com.theplantscape.svg-generation.ensemble
    :as svg
    :refer [generate-diagram]]
   [reagent.core :as r]))

#_[:filter#dropshadow {:x "0" :y "0" :width "200%" :height "200%"}
   ["feOffset" {:in "SourceAlpha" :dx "2" :dy "2" :result "offOut"}]
   ["feGaussianBlur" {:result "blurOut" :in "offOut" :stdDeviation "1"}]
   ["feBlend" {:in "SourceGraphic" :in2 "blurOut" :mode "normal"}]]

(defn ui-svg-diagram
  [{:keys [width height view-box] :as size}]
  (let [diagram (r/cursor site-data [:datalog-queries :boundary]) #_(select-bind nil fetch-diagram-settings)
        patch (r/cursor site-data [:datalog-queries :patch]) #_(select-bind :area select-structure)
        area (r/cursor site-data [:datalog-queries :area]) #_(select-bind :area select-structure)
        structure (r/cursor site-data [:datalog-queries :structure]) #_(select-bind :structure select-structure)
        path (r/cursor site-data [:datalog-queries :path]) #_(select-bind :path select-structure)
        family (r/cursor site-data [:datalog-queries :family]) #_(select-bind :canopy)
        canopy (r/cursor site-data [:datalog-queries :canopy]) #_(select-bind :canopy)
        tree (r/cursor site-data [:datalog-queries :sub-canopy]) #_(select-bind :canopy)
        shrub (r/cursor site-data [:datalog-queries :shrub]) #_(select-bind :shrub)
        herbaceous (r/cursor site-data [:datalog-queries :herbaceous]) #_(select-bind :herbaceous)
        ground (r/cursor site-data [:datalog-queries :ground]) #_(select-bind :ground)
        root (r/cursor site-data [:datalog-queries :root]) #_(select-bind :root)
        vine (r/cursor site-data [:datalog-queries :vine]) #_(select-bind :vine)
        plant (r/cursor site-data [:datalog-queries :plants]) #_(r/cursor app-state [:current :plant])]
    (fn [{:keys [width height view-box] :as size}]
      (prn "redraw")
      [generate-diagram
       (-> (svg/area-patterns @plant #_patch)
           (conj svg-no-pattern
                 svg-pattern-1
                 svg-pattern-2
                 svg-pattern-3
                 svg-pattern-4
                 tree-filter
                 goo-filter
                 bush-filter
                 ground-filter
                 hatch-filter))

       [[svg/boundary #{@diagram}]
        [svg/canopy-tree @family]
        [svg/canopy-tree @canopy]
        [svg/sub-canopy-tree @tree]
        [svg/bush @shrub]
        [svg/herbaceous @herbaceous]
        [svg/ground @ground]
        [svg/root @root]
        [svg/path @path]
        [svg/vine @vine]
        [svg/patch @patch]
        [svg/area @area]
        [svg/structure @structure]]])))

(comment
  (-> @site-data :datalog-queries :canopy)

  )
